
import * as bootstrap from 'bootstrap';

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

const toastBasic = function(message, title = '', classes = '') {
    let html = ''; let id = 'toast' + (new Date().getTime());
    html += '<div id="'+id+'" class="toast '+classes+'" role="alert" aria-live="assertive" aria-atomic="true">';
    html += '    <div class="toast-body">';
    html += '        <div class="d-flex gap-4">';
    html += '            <span><i class="fa-solid fa-circle-check fa-lg"></i></span>';
    html += '            <div class="d-flex flex-grow-1 align-items-center"><div class="toast-content">';
    if (title.length > 1) {
        html += '            <div class="toast-title fw-semibold">'+title+'</div>';
    }
    html += '                <span class="toast-msg">' + message + '</span></div>';
    html += '<button type="button" class="btn-close btn-close-sm btn-close-black ms-auto" data-bs-dismiss="toast" aria-label="Close"></button>';
    html += '            </div>';
    html += '        </div>';
    html += '    </div>';
    html += '</div>';

    $('#toasts').append(html);
    let t = new bootstrap.Toast(document.getElementById(id), {animation: true});
    t.show();
}

window.toast = function (message, title = '') {
    toastBasic(message, title);
}
window.toastSuccess = function (message, title = '') {
    toastBasic(message, title, 'text-bg-success');
}
window.toastError = function (message, title = '') {
    toastBasic(message, title, 'text-bg-danger');
}



String.prototype.toHHMMSS = function () {
    let sec_num = parseInt(this, 10); // don't forget the second param
    let hours = Math.floor(sec_num / 3600);
    let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    let seconds = sec_num - (hours * 3600) - (minutes * 60);

    if (hours < 10) {
        hours = "0" + hours;
    }
    if (minutes < 10) {
        minutes = "0" + minutes;
    }
    if (seconds < 10) {seconds = "0"+seconds;}
    return hours+':'+minutes+':'+seconds;
}

$.fn.datepicker.dates["de"] = {
    days: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
    daysShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    daysMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    months: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
    monthsShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    today: "Heute",
    clear: "Löschen",
    format: "dd.mm.yyyy",
    titleFormat: "MM yyyy",
};


window.partyPlaying = false;
window.partyTimout = null;

window.party = function() {
    if ($('body').hasClass('no-celebrations')) {
        return;
    }

    // stop previous timer
    if (window.partyTimeout) {
        window.clearTimeout(window.partyTimeout);
    }

    // destroy any existing confetti
    $('canvas.party').remove();

    // tell others
    window.partyPlaying = true;

    // create new paty canvas
    let myCanvas = document.createElement('canvas');
    myCanvas.className = 'party';
    document.body.appendChild(myCanvas);

    // create confetti generator
    let myConfetti = confetti.create(myCanvas, {
        resize: true,
        useWorker: true
    });

    // start confetti
    myConfetti({
        particleCount: 100,
        spread: 160
    });

    playChimeSound();

    window.partyTimeout = window.setTimeout(function(){
        $('canvas.party').remove();
        window.partyPlaying = false;
    }, 2000);
}

window.playBeepSound = function () {
    if ($('body').hasClass('no-sounds')) {
        return;
    }
    $('.beep-player').remove();

    // make a new audio element
    let player = document.createElement('audio');
    player.src = '/sounds/beep.mp3';
    player.volume = 1;

    // button class swapping event
    player.addEventListener('ended', function(){
        $('.beep-player').remove();
    });

    // make the element invisibe and append it to DOM
    let playerElement = $(player);
    playerElement.addClass('beep-player').addClass('d-none');
    $('body').append(playerElement);

    // play the sound of this instance
    player.play();
};

window.playErrorSound = function () {
    if ($('body').hasClass('no-sounds')) {
        return;
    }
    $('.beep-player').remove();

    // make a new audio element
    let player = document.createElement('audio');
    player.src = '/sounds/wrong.mp3';
    player.volume = 1;

    // button class swapping event
    player.addEventListener('ended', function(){
        $('.beep-player').remove();
    });

    // make the element invisibe and append it to DOM
    let playerElement = $(player);
    playerElement.addClass('beep-player').addClass('d-none');
    $('body').append(playerElement);

    // play the sound of this instance
    player.play();
};

window.playSuccessSound = function () {
    if ($('body').hasClass('no-sounds')) {
        return;
    }
    $('.correct-player').remove();

    // make a new audio element
    let player = document.createElement('audio');
    player.src = '/sounds/success-soft.mp3';
    player.volume = 1;

    // button class swapping event
    player.addEventListener('ended', function(){
        $('.correct-player').remove();
    });

    // make the element invisibe and append it to DOM
    let playerElement = $(player);
    playerElement.addClass('correct-player').addClass('d-none');
    $('body').append(playerElement);

    // play the sound of this instance
    player.play();
};

window.playChimeSound = function () {
    if ($('body').hasClass('no-sounds')) {
        return;
    }
    $('.chime-player').remove();

    // make a new audio element
    let player = document.createElement('audio');
    player.src = '/sounds/chime.mp3';
    player.volume = 1;

    // button class swapping event
    player.addEventListener('ended', function(){
        $('.chime-player').remove();
    });

    // make the element invisibe and append it to DOM
    let playerElement = $(player);
    playerElement.addClass('chime-player').addClass('d-none');
    $('body').append(playerElement);

    // play the sound of this instance
    player.play();
};

window.hexToHSL = function(hex) {
    hex = hex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16) / 255;
    const g = parseInt(hex.substring(2, 4), 16) / 255;
    const b = parseInt(hex.substring(4, 6), 16) / 255;

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;

    if (max === min) {
        h = s = 0; // Grau
    } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

        switch (max) {
            case r: h = ((g - b) / d + (g < b ? 6 : 0)); break;
            case g: h = ((b - r) / d + 2); break;
            case b: h = ((r - g) / d + 4); break;
        }

        h *= 60;
    }

    return {
        h: Math.round(h),
        s: Math.round(s * 100),
        l: Math.round(l * 100)
    };
}

window.setHarmoniousColorVariants = function(varName) {
    const root = getComputedStyle(document.documentElement);
    const hex = root.getPropertyValue(varName).trim();
    const { h, s, l } = hexToHSL(hex); // aus vorherigem Snippet

    const set = (name, h2, s2 = s, l2 = l) =>
        document.documentElement.style.setProperty(name, `hsl(${(h2 + 360) % 360}, ${s2}%, ${l2}%)`);

    set(`${varName}-complement`, h + 180);
    set(`${varName}-split1`, h + 150);
    set(`${varName}-split2`, h + 210);
    set(`${varName}-triad1`, h + 120);
    set(`${varName}-triad2`, h + 240);
    set(`${varName}-analog1`, h + 30);
    set(`${varName}-analog2`, h - 30);
    set(`${varName}-bright`, h, s, Math.min(l + 20, 95));
    set(`${varName}-bold`, h, Math.min(s + 20, 100), l);
    set(`${varName}-soft`, h, Math.max(s - 20, 10), l);
}

// Hauptfunktion zum Eintragen der abgeleiteten Farben
window.updateDerivedColorsFromHexVar = function(varName) {
    const root = getComputedStyle(document.documentElement);
    const hex = root.getPropertyValue(varName).trim();
    const hsl = hexToHSL(hex);

    document.documentElement.style.setProperty(`${varName}-hue`, hsl.h);
    document.documentElement.style.setProperty(`${varName}-saturation`, hsl.s + '%');
    document.documentElement.style.setProperty(`${varName}-lightness`, hsl.l + '%');
    document.documentElement.style.setProperty(`${varName}-complement`, `hsl(${(hsl.h + 180) % 360}, ${hsl.s}%, ${hsl.l}%)`);
    document.documentElement.style.setProperty(`${varName}-faded`, `hsla(${hsl.h}, ${hsl.s}%, ${hsl.l}%, 0.7)`);
}
